(function ($) {
  // redirect to url without access denied, if user clicked cancel at Facebook login
  if (window.location.href.indexOf('?error=access_denied') >= 0) {
    window.location.href = window.location.href.split('?')[0]
  }
}(jQuery))
